export const useUniversalHost = () => {
	const nuxtApp = useNuxtApp();
	const url = new URL(
		nuxtApp?.ssrContext?.event.node.req.url
			? `http://${nuxtApp?.ssrContext?.event.node.req.headers.host}${nuxtApp?.ssrContext?.event.node.req.url}`
			: window.location.href,
	);
	return url.host;
};
